<template>
    <div
        class="user-rating-form-section"
        :class="`rating-user-${userIn.id}${sectionIn.id}`">
        <b-button
            class="btn-user-rating-section-toggler"
            v-b-toggle="`user-rating-section-${userIn.id}`"
            :class="sectionAnsweredState"
            block
            variant="primary"
            @click="scrollToTopPanel">
            {{ userIn.full_name }}
            <span
                class="user-section-grade"
                v-if="sectionIn.type === 1">
                <span class="label">{{ $t('rating.points') }}</span
                >{{ getSectionUserGrade(sectionIn.id, userIn.id) }}
            </span>
        </b-button>

        <b-collapse
            :id="`user-rating-section-${userIn.id}`"
            :visible="userIndexIn === 0"
            accordion="user-ratings-section"
            role="tabpanel">
            <div class="user-rating-form-section-content">
                <design-2021-rating-tab-user-rating-section-item-component
                    v-for="(item, itemindex) in sectionIn.items"
                    :key="item.id"
                    :item-in="item"
                    :index-in="itemindex"
                    :rating-in="ratingIn"
                    :section-in="sectionIn"
                    :user-in="userIn">
                </design-2021-rating-tab-user-rating-section-item-component>

                <div class="user-rating-form-section-update-item">
                    <b-button
                        class="btn-update-rating-form-section btn-save"
                        variant="primary"
                        @click="saveForm">
                        {{ $t('common.save') }}
                    </b-button>
                </div>
            </div>
        </b-collapse>
    </div>
</template>

<script>
import $ from 'jquery';

export default {
    name: 'design-2021-rating-tab-rating-user-section-component',
    props: {
        userIn: {
            type: Object,
            required: true,
        },
        sectionIn: {
            type: Object,
            required: true,
        },
        userIndexIn: {
            type: Number,
            required: true,
        },
        ratingIn: {
            type: Object,
            required: true,
        },
    },
    methods: {
        getSectionUserGrade(section_id, user_id) {
            let total = 0;
            const self = this;
            this.ratingIn.sections.forEach(function (section, key) {
                if (section.id === section_id) {
                    section.items.forEach(function (item, key2) {
                        if (item.type === 1) {
                            if (item.answers.length) {
                                if (section.personal === 1) {
                                    item.answers.forEach(function (answer, key4) {
                                        if (
                                            answer.user_id === user_id &&
                                            answer.rating_form_id === self.ratingIn.forms[0].id
                                        ) {
                                            total += item.weight * answer.open_answer;
                                        }
                                    });
                                } else {
                                    total += item.weight * item.answers[0].open_answer;
                                }
                            }
                        } else {
                            if (item.answers.length) {
                                if (section.personal === 1) {
                                    item.answers.forEach(function (answer, key5) {
                                        item.options.forEach(function (option, key3) {
                                            if (
                                                option.id === answer.rating_option_id &&
                                                answer.user_id === user_id &&
                                                answer.rating_form_id === self.ratingIn.forms[0].id
                                            ) {
                                                total += item.weight * option.max;
                                            }
                                        });
                                    });
                                } else {
                                    item.options.forEach(function (option, key3) {
                                        if (option.id === item.answers[0].rating_option_id) {
                                            total += item.weight * option.max;
                                        }
                                    });
                                }
                            }
                        }
                    });
                }
            });

            return Math.round(total * 10) / 10;
        },

        saveForm() {
            this.$emit('save-form');
        },

        scrollToTopPanel() {
            const self = this;
            Vue.nextTick(() => {
                const scrollPos = $(`.rating-user-${self.userIn.id}${self.sectionIn.id}`).offset().top - 25;
                $('.main-content').animate({ scrollTop: scrollPos }, 500);
            });
        },
    },
    computed: {
        sectionAnsweredState() {
            let answers = 0;
            for (const item of this.sectionIn.items) {
                if (item.answers.length) {
                    for (const answer of item.answers) {
                        answer.user_id === this.userIn.id && answers++;
                    }
                }
            }
            return answers === this.sectionIn.items.length
                ? 'section-answered'
                : answers === 0
                  ? null
                  : 'section-partial-answered';
        },
    },
};
</script>

<style scoped lang="scss">
.user-rating-form-section {
    .btn-user-rating-section-toggler {
        position: relative;
        text-align: left;
        display: flex;
        flex-direction: column;
        line-height: 1;
        font-size: 1.125rem;
        font-weight: $font-weight-medium;

        .user-section-grade {
            font-size: 0.75rem;
            font-weight: $font-weight-normal;

            .label {
                margin-right: map-get($grid-padding-spacing, 'eight');
                font-weight: $font-weight-normal;
            }
        }

        &.collapsed {
            background-color: rgba($black, 0.1);
            border-color: rgba($black, 0.1);
        }

        &.not-collapsed {
            background-color: $primary;
            border-color: $primary;
        }

        &.section-answered.collapsed,
        &.section-partial-answered.collapsed {
            background-color: rgba($primary, 0.35);
            border-color: rgba($primary, 0.35);
        }

        &.section-answered {
            &:before {
                content: '';
                width: 21px;
                height: 21px;
                background-color: $success;
                border-radius: 50%;
                display: block;
                position: absolute;
                right: 15px;
                top: calc(50% - 10.5px);
            }

            &:after {
                content: '\f00c';
                font-family: 'Font Awesome 5 Pro';
                font-weight: $font-weight-normal;
                font-size: $default-font-size;
                display: block;
                position: absolute;
                top: calc(50% - 6px);
                right: 18px;
                color: $white;
            }
        }
    }

    .user-rating-form-section-update-item {
        display: flex;
        justify-content: center;
        margin-top: map-get($grid-gutter-spacing, 'forty-two');
    }

    &:not(:last-child) {
        margin-bottom: map-get($grid-gutter-spacing, 'fifteen');

        .user-rating-form-section-update-item {
            margin-bottom: map-get($grid-gutter-spacing, 'forty-two');
        }
    }
}
</style>
